// extracted by mini-css-extract-plugin
export var variantListItem = "VariantListItem-module--variantListItem--00174";
export var variantSymbol = "VariantListItem-module--variantSymbol--ffb05";